<script setup lang="ts">
import IconExclamationCircle from '@/components/icons/IconExclamationCircle.vue'
withDefaults(
  defineProps<{
    errorMessage?: string
  }>(),
  {
    errorMessage: undefined,
  }
)
</script>

<template>
  <p v-if="errorMessage" :class="$style.error">
    <IconExclamationCircle /> {{ errorMessage }}
  </p>
</template>

<style lang="scss" module>
.error {
  color: $color-caution-accent;
  font-size: 12px;
  font-weight: 700;
  line-height: 21.6px;
  overflow-wrap: break-word;
}
</style>
